import { IAffairPub, IAttachment, IAttachmentImage } from "@api/affair.int";
import { Box, Divider, Icon, Image } from "@chakra-ui/react";
import { useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvCard, VizvCardAction, VizvCardActionStrip, VizvCardContent, VizvCardHeader2 } from "components/vizvComponents";
import React, { useEffect, useState } from "react";
import { MdMovie, MdPlayCircleOutline } from "react-icons/md";
import { useNavigate } from "react-router";
import { IAttachmentWKey } from "./Affair";



export interface AffairPopupProps {
	affair: IAffairPub;
	onClose: () => void;
}

export function AffairPopup({ affair, onClose, ...rest }: AffairPopupProps) {

	const nav = useNavigate();
	const mapNavRoot = useVVStore(state => state.mapNavRoot);
	const [attachmentsArr, setAttachmentsArr] = useState<Array<IAttachmentWKey>>([]);
	useEffect(() => {
		setAttachmentsArr(Object.entries(affair.attachments).splice(0,3).map(([k, o]) => ({...o, attachmentKey: k})));
	}, [affair.attachments]);

	const onClick = () => {
		onClose();
		nav(mapNavRoot+'/affair/' + affair.affairKey);
	}
	const onAttachmentClick = (e : React.MouseEvent, att : IAttachmentWKey) => {
		e.stopPropagation();
		onClose();
		nav(mapNavRoot+'/affair/' + affair.affairKey + '/attachment/' + att.attachmentKey);
	}

	return <VizvCard fontSize='md' cursor='pointer' onClick={onClick}>
		<VizvCardHeader2 kind={affair.affairKind} fontSize='md' >{affair.title}</VizvCardHeader2>
		<VizvCardContent>
			{formatDateTime(affair.createdAt)}<br />
			{affair.user.userName}<br />
			<Divider />
			{affair.description}<br />
			<Divider />
			<Box display='flex' flexDir='row' gap={2} p={2}>
				{attachmentsArr.map((att, ax) => <Box key={ax} onClick={e => onAttachmentClick(e,att)}>
					{att.attachKind === 'uploded_image' && <Image src={'https://uploads.vizvedok.hu/' + (att as any as IAttachmentImage).key}
						objectFit='cover' flex={1} overflow='hidden' display='flex' alignItems='center' justifyContent='center'
						width='64px' height='64px'
					/>}
					{att.attachKind !== 'uploded_image' && <Box
						width='64px' height='64px' border='1px solid #8888'
						display='flex' justifyContent='center' alignItems='center'
					><Icon as={MdPlayCircleOutline} fontSize='4xl' /></Box>}
				</Box>)}
			</Box>



		</VizvCardContent>
	</VizvCard>

}